import React from 'react';
import { X, AlertCircle, CheckCircle2, Info } from 'lucide-react';

export type ToastType = 'error' | 'success' | 'info';

export interface ToastItem {
  id: number;
  type: ToastType;
  message: string;
}

interface ToastContainerProps {
  toasts: ToastItem[];
  onDismiss: (id: number) => void;
}

const TYPE_STYLE: Record<ToastType, { bg: string; border: string; text: string; Icon: React.FC<{ size?: number; className?: string }> }> = {
  error:   { bg: 'bg-brand-50',   border: 'border-brand-200',   text: 'text-brand-700',   Icon: AlertCircle },
  success: { bg: 'bg-green-50', border: 'border-green-200', text: 'text-green-700', Icon: CheckCircle2 },
  info:    { bg: 'bg-blue-50',  border: 'border-blue-200',  text: 'text-blue-700',  Icon: Info },
};

export const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onDismiss }) => {
  if (toasts.length === 0) return null;

  return (
    // 위치: 모바일은 하단 중앙(탭바 위), 데스크톱은 상단 중앙 — 헤더 액션(우상단)도 입력바(하단)도 덮지 않는 유일한 자리
    <div className="fixed z-[60] flex flex-col gap-2 pointer-events-none left-1/2 -translate-x-1/2 w-[calc(100%-2rem)] max-w-sm bottom-[calc(env(safe-area-inset-bottom)+5rem)] md:bottom-auto md:top-5">
      {toasts.map((t) => {
        const style = TYPE_STYLE[t.type];
        const Icon = style.Icon;
        return (
          <div
            key={t.id}
            role="status"
            aria-live="polite"
            className={`pointer-events-auto flex items-start gap-2 pl-4 pr-2 py-2.5 rounded-xl border shadow-md animate-slide-up ${style.bg} ${style.border} ${style.text}`}
          >
            <Icon size={18} className="shrink-0 mt-[7px]" aria-hidden="true" />
            <span className="flex-1 text-sm py-1.5">{t.message}</span>
            <button
              type="button"
              onClick={() => onDismiss(t.id)}
              className="shrink-0 p-2 rounded-lg opacity-60 hover:opacity-100 hover:bg-black/5 transition-opacity"
              aria-label="닫기"
            >
              <X size={16} aria-hidden="true" />
            </button>
          </div>
        );
      })}
    </div>
  );
};
